/**
 * Date helper functions for Worthly
 */

/**
 * Get a month key string from a date (e.g., "2024-01")
 * @param {Date} date - The date to convert
 * @returns {string} Month key in format "YYYY-MM"
 */
export const getMonthKey = (date) => {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
};

/**
 * Get the number of days in a month
 * @param {number} year - The year
 * @param {number} month - The month (0-indexed)
 * @returns {number} Number of days in the month
 */
export const getDaysInMonth = (year, month) => {
  return new Date(year, month + 1, 0).getDate();
};

/**
 * Get the day of week for the first day of a month
 * @param {number} year - The year
 * @param {number} month - The month (0-indexed)
 * @returns {number} Day of week (0 = Sunday, 6 = Saturday)
 */
export const getFirstDayOfMonth = (year, month) => {
  return new Date(year, month, 1).getDay();
};

/**
 * Check if a day is today
 * @param {Date} date - Unused (kept for API compatibility)
 * @param {number} day - The day of month to check
 * @param {Date} currentMonth - The month being viewed
 * @returns {boolean} True if the day is today
 */
export const isToday = (date, day, currentMonth) => {
  const today = new Date();
  return (
    today.getDate() === day &&
    today.getMonth() === currentMonth.getMonth() &&
    today.getFullYear() === currentMonth.getFullYear()
  );
};

/**
 * Check if a day is in the future
 * @param {Date} date - Unused (kept for API compatibility)
 * @param {number} day - The day of month to check
 * @param {Date} currentMonth - The month being viewed
 * @returns {boolean} True if the day is in the future
 */
export const isFutureDay = (date, day, currentMonth) => {
  const today = new Date();
  const checkDate = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), day);
  today.setHours(0, 0, 0, 0);
  checkDate.setHours(0, 0, 0, 0);
  return checkDate > today;
};
